export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/about": [3],
		"/allCertificates": [4],
		"/allClients": [5],
		"/allInstallations": [6],
		"/allLogs": [7],
		"/baskettest": [9],
		"/basket": [8],
		"/contact": [10],
		"/cookiepolicy": [11],
		"/dropbox": [12],
		"/error": [13],
		"/faq": [14],
		"/feedback": [15],
		"/googledrive": [16],
		"/login": [17],
		"/logout": [18],
		"/onedrive": [19],
		"/passreset": [20],
		"/privacypolicy": [21],
		"/profile": [22],
		"/purchasecomplete": [24],
		"/purchase": [23],
		"/register": [25],
		"/resetvcode": [27],
		"/reset": [26],
		"/success": [28],
		"/support": [29],
		"/verify": [30]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';